export const DeviationSubjectType = { project: 0, order: 1, receipt: 2, customer: 3, plant: 4, price_agreement: 5, invoice: 6 };
export const DeviationSeverity = { warning: 0, blocking: 1 };
export const DeviationCategory = { planning: 0, production: 1, quantity: 2, pricing: 3, price_agreement: 4, customer: 6, invoicing: 7 };

export const CustomerDeviationType = { blocked: 0, lagging_behind_invoices: 1 };
export const ProjectDeviationType = { missing_location: 0, missing_travel_info: 1 };
export const OrderDeviationType = {
   missing_recipe: 0, not_planned: 1, multi_day_price_changed: 2, not_produced: 3, partially_produced: 4,
   overproduced: 5, other_producing_plant: 6, overdue: 7, lagging_behind: 8, missing_price_usage: 9
};
export const InvoiceDeviationType = { waitingForApproval: 0, overdue: 1 }

export const PlantDeviationType = { other_producing_plant: 0 };
export const ReceiptDeviationType = { cancelled: 0, dropped: 1, missing_amount: 2 };
export const PriceAgreementDeviationType = { blocked: 0, expired: 1, changed: 2 };
